import React from 'react';
import ctaImg from '../../assets/images/cta-img.png';
import phoneIcon from '../../assets/images/icons/phone-call.png';

function Cta() {
  return (
    <div className="cta-wrapper d-flex align-items-center flex-wrap flex-md-nowrap">
      <div
        className="cta-img bg-cover"
        style={{ backgroundImage: `url(${ctaImg})` }}
      />
      <div className="cta-details d-flex flex-wrap">
        <div className="cta-icon d-flex justify-content-sm-center">
          <img src={phoneIcon} alt="phone" />
        </div>
        <div>
          <h3 className="cta-heading">
            Have questions? Call us
            <span className="cta-num"> +1 302 246 1000</span>
          </h3>
          <span className="cta-text">
            Building a house and interior desig is not a problem for our
            employees!
          </span>
        </div>
      </div>
    </div>
  );
}

export default Cta;
